import React, { useContext, useState } from "react";

import InterestContext from "../../context/interest/interestContext";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import AuthContext from "../../context/auth/authContext";
import { californiaZips } from "../../data/californiaZipCodes";
import ReadModal from "./ReadModal";

import Address1 from "./Address1";
import Address2 from "./Address2";
import CompleteMessage from "./CompleteMessage";
import GetEmail from "./GetEmail";
import InitialQuestions from "./InitialQuestions";
import ParentsInfo from "./ParentsInfo";
import ProgressCircles from "./ProgressCircles";
import Summary from "./Summary";

const InterestForm = ({ type }) => {
  const [showModal, setShowModal] = useState(false);
  const [readTerms, setReadTerms] = useState(false);
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const authContext = useContext(AuthContext);
  const interestContext = useContext(InterestContext);
  const [orientationType, setOrientationType] = useState("VIRTUAL");
  const { setFormModal, sendOrientationEmail } = adminRegistrationContext;
  const { user } = authContext;
  const {
    formLevel,
    submitDataPublic,
    formData,
    _uuid,
    age,
    sendInterestEmail,
    zipSearch,
  } = interestContext;
  const isCaliforniaZip = californiaZips.includes(zipSearch.zipcode);

  const {
    studentFirstName,
    studentLastName,
    primaryEmail,
    learningCenterName,
    learningCenterCharter,
    learningCenterAddress,
    charterWebsite,
    charterContactnumber,
    site_id,
    brandIcon,
    principal,
    parentFirstName,
    parentLastName,
  } = formData;

const onSubmit = async (e) => {
  e.preventDefault();
  console.log("Submitting interest form..."); // Debug log
  const interestRecordId = await submitDataPublic({
    ...formData,
    age,
  });

  console.log("Received Interest Record ID in onSubmit:", interestRecordId); // Debug log

  // Send email with the interest record ID
  if (interestRecordId) {
    console.log("Calling sendInterestEmail with ID:", interestRecordId); // Debug log
    sendInterestEmail(formData, interestRecordId);
  } else {
    console.warn("No interest record ID received, sending email without ID"); // Debug log
    // Still send email even if ID is not available
    sendInterestEmail(formData, null);
  }
};


 
  return (
    <div id='interest-form'>
      <ProgressCircles />
      <form onSubmit={onSubmit} className="form">
        <div className="form-container">
          {formLevel === 0 && <InitialQuestions />}
        
          {formLevel === 6 && <CompleteMessage />}
          {showModal && <ReadModal setModal={setShowModal} />}
        </div>
      </form>
    </div>
  
  );
};
export default InterestForm;
